import React, { useLayoutEffect, useContext, useState } from 'react';
import { useTranslation } from 'react-i18next';

import * as S from './styles';
import { UseTranslationProps } from 'types/UseTranslationProps';
import TitleNavBarContext from 'context/TitleNavBarContext';
import { TabSettingPageProps } from 'types/TabSettingPageProps';
import { tabsList } from './listTabsflag';
import TabsSettingsProps from 'components/TabsSettings';
import ComponentsAdm from 'components/ComponentsAdm';
import PagesAdm from 'components/PagesAdm';
import WhitelistAdm from 'components/WhitelistAdm';

export default function AdmPainel() {
	const { i18n }: UseTranslationProps = useTranslation();
	const { setDataAbouTitle } = useContext(TitleNavBarContext);

	const [listTabs, setListTabs] = useState<TabSettingPageProps[]>(tabsList);
	const [optionActive, setOptionActive] = useState(0);

	// Para colocar na tela o componente desejado
	useLayoutEffect(() => {
		listTabs.forEach((item: TabSettingPageProps) => {
			if (item.isSelected === true) {
				setOptionActive(item.id);
			}
		});
	}, [listTabs]);

	//muda titulo do componente
	useLayoutEffect(() => {
		setDataAbouTitle((value) => ({
			...value,
			title: 'navBarOptions.adminPainel'
		}));
	}, [i18n?.language]);

	return (
		<S.container>
			<TabsSettingsProps setTabsList={setListTabs} tabsList={listTabs} />

			<ComponentsAdm isVisiable={optionActive === 0} />
			<PagesAdm isVisiable={optionActive === 1} />
			<WhitelistAdm isVisiable={optionActive === 2} />
		</S.container>
	);
}
